import api from "@/tools/Api";
import urls from "@/tools/Urls";
import message from "@/tools/Message";

export default {
  async getCertWithQuery(id) {
    try {
      return await api.get(urls.api("get_cert_with_query", [id]));
    } catch (e) {
      console.log(e);
      message.error(e.response.data.Message);
      return e;
    }
  },
};
